import React, { Component, Fragment } from 'react';
import { Button, Form, Input, Label } from 'reactstrap';
import { connect } from 'react-redux';
import Dialog from 'apa/containers/Dialog';
import autobind from 'autobind-decorator';
import { add } from 'catalog/actions/measures'
@connect(
    null,
    dispatch => ({
        add: (name) => dispatch(add(name))
    })
)
export default class AddMeasureModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            measureName: ''
        };
    }
    render() {
        return (<Fragment>
            <Button color='primary' size='sm' title="Maßnahme hinzufügen" onClick={this.toggle}>
                <i className='fa fa-plus'> </i> Maßnahme hinzufügen
                </Button>
            <Dialog isOpen={this.state.isOpen} toggle={this.toggle} confirm={this.confirm} title="Maßnahme hinzufügen">
                <Form>
                    <Label>
                        Bezeichnung
                        </Label>
                    <Input type='text' onChange={e => this.setState({ measureName: e.target.value })} />
                </Form>
            </Dialog>
        </Fragment>);
    }
    @autobind
    confirm() {
        this.props.add(this.state.measureName)
        this.toggle()
    }
    @autobind
    toggle() {
        const isOpen = !this.state.isOpen
        this.setState({isOpen})
    }
}
